module.exports = {"id":"223388","name":"Alexandr Sukhov","rating":"71","photo":"./data/images/photos/0/223388.png","club":{"name":"FK Oufa","logo":"./data/images/clubs/FKOufa.png"},"positions":["DLD","DG","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexandrSukhov0.json
// module id = 251
// module chunks = 0